import axios from 'axios';

const api_vistoria = axios.create({ baseURL: process.env.REACT_APP_EPAR_API_URL });

export {
  api_vistoria,
}
